export const handleChangePairingDropdown = (state, payload) => {
    return {
        ...state,
        pairingTableDropDownValue: payload.value
    }
}